import React, { FC } from 'react';
import styled from 'styled-components';

import CrossIcon from '../../assets/images/icons/cross.svg';
import { basic, grey } from '../../theme/colors';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  onClick: (e: any) => void;
  disabled?: boolean;
  isEnabled?: boolean;
}

const Label = styled.span`
  &:hover {
    background: ${basic.haydenLightSteel3};
    border-color: ${basic.haydenLightSteel3};
  }

  &:focus {
    background: ${basic.haydenLightSteel4};
    border-color: ${basic.haydenLightSteel4};
  }
`;

const Close = styled.img`
  margin-left: 4px;
`;

const Button = styled.button`
  display: inline-block;
  color: ${grey.haydenGreyShade1};
  font-size: 12px;
  line-height: 14px;
  font-weight: 400;
  background: ${basic.haydenBorder};
  text-align: center;
  border-radius: 4px;
  padding: 4px 8px;
  color: ${basic.haydenAccent};
  border: none;
  margin-right: 8px;
  margin-bottom: 4px;
`;

export const ToggleButton: FC<Props> = (props) => {
  const { children, isEnabled, ...rest } = props;
  return (
    <Button type="button" {...rest} className={`toggle-button ${isEnabled ? 'selected' : ''}`}>
      <Label>{children}</Label>
      <Close alt="Remove filter" src={CrossIcon} />
    </Button>
  );
};
